export default __webpack_public_path__ + "static/media/KZ.T.05.0294.331db56b.svg";